import { useEffect } from 'react';
import { fmt } from '@/lib/utils';

export default function CfgVariantes({ producto, onUpdate, catalogo }) {
  const cfg = producto.config || { variante: catalogo.variantes[0].id, precioCustom: null };

  const recalc = (newCfg) => {
    const v = catalogo.variantes.find((va) => va.id === newCfg.variante);
    const precio =
      newCfg.precioCustom !== null && newCfg.precioCustom !== undefined
        ? newCfg.precioCustom
        : v.precio;
    onUpdate({ config: newCfg, precioFinal: precio });
  };

  useEffect(() => {
    if (!producto.configurado) recalc(cfg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2">
        {catalogo.variantes.map((v) => (
          <button
            key={v.id}
            onClick={() => recalc({ variante: v.id, precioCustom: null })}
            className={`p-3 rounded-lg border text-left text-sm ${
              cfg.variante === v.id
                ? 'border-brand-gold bg-brand-gold/10'
                : 'border-neutral-800 bg-neutral-900/50 hover:border-neutral-700'
            }`}
          >
            <div className="text-white mb-1">{v.label}</div>
            <div className="text-brand-gold font-medium text-xs">{fmt(v.precio)}</div>
          </button>
        ))}
      </div>
      <div className="p-2 bg-black/30 rounded border border-neutral-900 flex items-center gap-2">
        <span className="text-[10px] text-neutral-500 uppercase tracking-wider">
          Precio final (editable)
        </span>
        <input
          type="number"
          value={producto.precioFinal || 0}
          onChange={(e) =>
            recalc({ ...cfg, precioCustom: parseFloat(e.target.value) || 0 })
          }
          className="flex-1 px-2 py-1 bg-neutral-900 border border-neutral-800 rounded text-xs text-white text-right focus:outline-none focus:border-brand-gold/50"
        />
      </div>
    </div>
  );
}
